import { IConstant } from 'types';

export const FiasTypes: IConstant[] = [
  {
    value: 'houses',
    text: 'Дома',
  },
  {
    value: 'groups',
    text: 'Группы',
  },
];
